var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('config-item',{attrs:{"label":_vm.label}},[_c('el-slider',_vm._b({attrs:{"show-input":""},on:{"change":_vm.changeNum},model:{value:(_vm.num),callback:function ($$v) {_vm.num=$$v},expression:"num"}},'el-slider',_vm.mOptions,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }